import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
    updateComplementary,
    getComplementaryDataWithId,
    getRoomType,
} from "adminApi/ComplementaryApi/Complementary";
import { validateForm } from "utils/validation";
import { ComplementaryRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import fields from "../json/ComplementaryListField.json";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import useFetchFormDataById from "Hooks/useFetchFormDataById";
import useFetchAllData from "Hooks/useFetchAllData";
import EditComplementaryForm from "./Components/EditComplementaryForm";

const EditComplementary = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const { formdata } = fields;

    // Build initial values from field definitions
    const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});

    const { values, errors, handleChange, setValues, setErrors } = useFormChange(
        initialValues,
        ComplementaryRules
    );

    // Fetch existing record by ID and populate form
    const { loading: loadingFetch } = useFetchFormDataById(
        id,
        formdata,
        getComplementaryDataWithId,
        setValues
    );

    // Fetch room types for the select dropdown — in parent, not in form
    const { data: roomTypeOptions, loading: loadingRoomType } = useFetchAllData(getRoomType);

    const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
        // Send plain JSON — no file uploads in this form
        async (formValues) => await updateComplementary({ id, data: formValues }),
        (vals) => {
            const err = validateForm(vals, ComplementaryRules);
            setErrors(err);
            return err;
        },
        () => navigate(-1),
        "Complementary updated successfully"
    );

    return (
        <>
            {(loadingFetch || loadingSubmit || loadingRoomType) && <Spinner isSpinner={true} />}
            <EditComplementaryForm
                fields={formdata}
                values={values}
                errors={errors}
                handleChange={handleChange}
                handleSubmit={(e) => handleSubmit(e, values)}
                loading={loadingSubmit}
                roomTypeOptions={roomTypeOptions || []}
                title="Edit Complementary"
            />
        </>
    );
};

export default EditComplementary;
